var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(-5060 -5766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4b2015755201e3afc6df8dd8139bcb37",
    "data-name": "4b2015755201e3afc6df8dd8139bcb37",
    transform: "translate(5058.78 5764.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M12.094,7.25a.844.844,0,0,1,.844.844v4.151L15.5,14.81A.844.844,0,1,1,14.31,16L11.5,13.191a.843.843,0,0,1-.247-.6v-4.5A.844.844,0,0,1,12.094,7.25Z",
    transform: "translate(1.126 0.625)",
    fill: "#16ebc3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M5.433,5.422a11.021,11.021,0,0,1,15.58,15.591,11.042,11.042,0,0,1-18.66-9.389.844.844,0,1,1,1.672.229,9.354,9.354,0,0,0,15.8,7.966A9.333,9.333,0,0,0,6.626,6.615l.841,0a.844.844,0,0,1-.008,1.688L4.595,8.292a.844.844,0,0,1-.84-.84L3.741,4.589A.844.844,0,0,1,5.428,4.58Z",
    transform: "translate(0 0)",
    fill: "#16ebc3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 24,
    height: 24,
    transform: "translate(5060 5766)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.838b11838d04f6ebbd3a89d633dfa441.svg";
export { ForwardRef as ReactComponent };